// extracted by mini-css-extract-plugin
export default {"cell":"LwCUoc7OJ0HzkCAf5EEU","title":"Qr9zOny2dfco6C3KXbDe","info":"RLxVav6ZHuVwtbcPwIcK","adornment":"SuGzBussf9pTm1pp2csy"};